/**
 * Ajuda dos campos de assinaturas (P-MIN-4): a configuracao do provedor e os filtros
 * dos pedidos. Ver docs/ADR/0062-assinatura-por-provedor.md.
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 */
export const ajuda: Record<string, Record<string, string>> = {
  '/assinaturas': {
    'Provedor de assinatura':
      'Provedor que recebe o documento e colhe as assinaturas. So aparecem os ligados nesta instalacao: a credencial de cada um fica no servidor, nunca aqui.',
    'Prazo da assinatura em dias':
      'Dias corridos para os signatarios assinarem, de 1 a 90. Vencido o prazo, o provedor encerra o pedido.',
    'Nome do signatario da seguradora':
      'Quem assina pela seguradora. Entra no pedido com a opcao Incluir o signatario da seguradora e no pedido automatico.',
    'E-mail do signatario da seguradora':
      'Por este e-mail o provedor envia o pedido de assinatura e o codigo de confirmacao.',
    'CPF do signatario da seguradora':
      'Opcional. O provedor confere a identidade com ele. Depois de gravado aparece so o final; em branco mantem o gravado.',
    'Autenticacao do signatario da seguradora':
      'Codigo por e-mail, o padrao, ou assinatura automatica em nome da pessoa, ainda a decidir (D27). A automatica exige a autorizacao da pessoa no provedor.',
    'Situacao do pedido':
      'Filtra os pedidos pela situacao. Os cartoes acima contam o mesmo recorte, sem este filtro.',
    'Buscar pedido':
      'Busca pelo numero do pedido, pelo documento e pelo nome ou e-mail dos signatarios.',
  },
};
